import React from 'react';
import { DOC_TYPE_WAR, HTML_DOC_TYPE } from '../../../helpers/constants';
import { checkURL } from '../../../helpers/utils';
import store from '../../../stores/store';
import { Online, Offline } from '../../_shared/conn';

export default class WarDocCard extends React.Component {
    onClick = () => {
        // const doc = this.props.doc;
        this.props.markDocAsRead(this.props.doc.WarDocId);

        this.fetchDocument();
    };

    fetchDocument = () => {
        const doc = this.props.doc;
        store.documents
            .fetchDocument(
                {
                    instanceId: 0,
                    docTypeId: DOC_TYPE_WAR,
                    docId: doc.WarDocId,
                    DocExtension: doc.DocExtension,
                    DocPermissions: doc.DocPermissions,
                    DocName: doc.DocName,
                    fromHistory: null,
                    onClose: null,
                },
                true,
            )
            .catch(error => {
                console.log('error fetching doc - WAR card');
            });
    };

    render() {
        const { doc, isNew } = this.props;

        if (doc.DocType !== HTML_DOC_TYPE) {
            return (
                <div
                    className={`card ${doc.IsFeature ? 'card-featured ' : ''}war-card-article`}
                    onClick={() => this.onClick()}
                >
                    {isNew ? <span className="badge badge-primary">New</span> : null}
                    <img className="card-img-top img-fluid" src={doc.localImageUrl} alt="" />
                    <div className="card-block">
                        <h6>{doc.DocName}</h6>
                        <p className="small text-muted war-author">{doc.Author}</p>
                        <p className="card-text">{doc.DocDescription}</p>
                    </div>
                </div>
            );
        } else {
            return (
                <div style={{ width:'100%' }}>
                    <Online>
                        <a
                            className={`card ${doc.IsFeature ? 'card-featured ' : ''}war-card-article`}
                            onClick={() => this.props.markDocAsRead(this.props.doc.WarDocId)}
                            href={checkURL(doc.DocUrl)}
                            target="__black"
                        >
                            {isNew ? <span className="badge badge-primary">New</span> : null}
                            <img className="card-img-top img-fluid" src={doc.localImageUrl} alt="" />
                            <div className="card-block">
                                <h6>{doc.DocName}</h6>
                                <p className="small text-muted war-author">{doc.Author}</p>
                                <p className="card-text">{doc.DocDescription}</p>
                            </div>
                        </a>
                    </Online>
                    <Offline>
                        <a title="! OFFLINE" className={`card ${doc.IsFeature ? 'card-featured ' : ''}war-card-article`}>
                            {isNew ? <span className="badge badge-primary">New</span> : null}
                                <img className="card-img-top img-fluid" src={doc.localImageUrl} alt="" />
                                <div className="card-block">
                                    <h6>{doc.DocName}</h6>
                                    <p className="small text-muted war-author">{doc.Author}</p>
                                    <p className="card-text">{doc.DocDescription}</p>
                                </div>
                        </a>
                    </Offline>   
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/War/WarDocCard.js